import DateFormatter from '../shared/utils/DateFormatter';

export class PsContractorFile {

    _id; // number
    _name; // string
    _file; // string
    _contractorId; // number
    _contractorName; // string
    _contractorNif; // string
    _date; // string
    _canDelete; // boolean

    constructor(
        id,
        name,
        file,
        contractorId,
        contractorName,
        contractorNif,
        date,
        canDelete
    ) {
        this._id = id;
        this._name = name;
        this._file = file;
        this._contractorId = contractorId;
        this._contractorName = contractorName;
        this._contractorNif = contractorNif;
        this._date = date;
        this._canDelete = canDelete;
    }

    static fromApiContractorFiles(contractorFiles) {
        return contractorFiles.map(contractorFile => PsContractorFile.fromApiContractorFile(contractorFile));
    }

    static fromApiContractorFile(contractorFile) {
        return new this(
            contractorFile.id,
            contractorFile.name,
            contractorFile.file,
            contractorFile.contractor.id,
            contractorFile.contractor.name,
            contractorFile.contractor.nif,
            contractorFile.date,
            contractorFile.can_delete
        )
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    file() {
        return this._file;
    }

    contractorId() {
        return this._contractorId;
    }

    contractorName() {
        return this._contractorName;
    }

    contractorNif() {
        return this._contractorNif;
    }

    date() {
        return DateFormatter.formatDate(this._date);
    }

    canDelete() {
        return this._canDelete;
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/PsContractorFile.js